import { TradingLoadingButton, TradingTextField } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { CreatePricingIndexPayload } from '@/api/services/settings/pricing-indices.service';

import * as styles from './Form.css';

type Props = {
  form: CreatePricingIndexPayload;
  isSubmitting: boolean;
  errors: Partial<Record<keyof CreatePricingIndexPayload, string>>;
  updateField: (field: keyof CreatePricingIndexPayload, value: string) => void;
  handleSubmit: () => void;
  type: 'create' | 'update';
};

export default function PricingIndexForm({ form, isSubmitting, errors, updateField, handleSubmit, type }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.formContainer}>
      <TradingTextField
        label={t('settings.pricingIndicesTab.modal.nameLabel')}
        value={form.name}
        onChange={(e) => updateField('name', e.target.value)}
        error={!!errors.name}
        helperText={errors.name}
      />
      <TradingTextField
        label={t('settings.pricingIndicesTab.modal.timeLimitLowerLabel')}
        value={form.timeLimitLower}
        onChange={(e) => updateField('timeLimitLower', e.target.value)}
        error={!!errors.timeLimitLower}
        helperText={errors.timeLimitLower}
        type="time"
      />
      <TradingTextField
        label={t('settings.pricingIndicesTab.modal.timeLimitUpperLabel')}
        value={form.timeLimitUpper}
        onChange={(e) => updateField('timeLimitUpper', e.target.value)}
        error={!!errors.timeLimitUpper}
        helperText={errors.timeLimitUpper}
        type="time"
      />
      <TradingLoadingButton
        label={
          type === 'create'
            ? t('settings.pricingIndicesTab.modal.createButton')
            : t('settings.pricingIndicesTab.modal.updateButton')
        }
        handleClick={handleSubmit}
        className={styles.button}
        loading={isSubmitting}
      />
    </div>
  );
}
